// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__qL116","footer":"ChangeClinic_footer__OS5JU"};